import { getChainId } from '../../lib';

// GET /discounts devolve 400 "Informe a rede" sem filter.chainId (nem chainId na query).
export const hasDiscountChain = (filter?: { chainId?: unknown }, sessionChainId?: unknown): boolean =>
  Boolean(filter?.chainId || sessionChainId);

// `enabled` do react-query v5 aceita função da query; a chave do useGetList é
// [resource, 'getList', { pagination, sort, filter, meta }] (ver inactiveCustomersFilter.ts).
export const discountListQueryOptions = {
  enabled: (query: { queryKey: readonly unknown[] }) =>
    hasDiscountChain((query.queryKey[2] as { filter?: { chainId?: unknown } } | undefined)?.filter, getChainId()),
};
